import { SynqlyAuth } from '@synqly/ui/pages/auth'
import { authConfig } from '../api/auth/[...backoffice-auth]'

export { AuthPage as default, getServerSideProps }

const { AuthPage, getServerSideProps } = SynqlyAuth(authConfig)
